import { render, staticRenderFns } from "./ReplacementContainer.vue?vue&type=template&id=2a605f61"
import script from "./ReplacementContainer.vue?vue&type=script&lang=js"
export * from "./ReplacementContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports